export default __webpack_public_path__ + "static/media/SuccessfullySubmitted.efe0cf72.svg";